export default __webpack_public_path__ + "static/media/email_icon.09f6c475.svg";